import { isFulfilled } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { act } from "react-dom/test-utils";

const initialState = {
  editLayer: null,
  editableLayers: {},
  history: [
    { type: "init", geojson: null, featureId: "Initial layer", index: 0 },
  ],
  copied: [],
  selectedFeature: null,
  highlightedFeatures: [],
  editConfig: {
    spatialType: "draw",
    selected: [],
  },
  mergeDefaultFeature: null,
};

export default function editReducer(state = initialState, action) {
  switch (action.type) {
    case "loadconfiguration":
      {
        return {
          editLayer: null,
          editableLayers: {},
          history: [],
          selectedFeature: null,
          highlightedFeatures: [],
          editConfig: {
            spatialType: "draw",
            selected: [],
          },
          mergeDefaultFeature: null,
        };
      }
      break;

    case "edit/addtohistory":
      {
        let newState = { ...state };

        newState.history.unshift(action.payload);

        return newState;
      }

      break;

    case "edit/addtocopied":
      {
        let newState = { ...state };

        newState.copied.push(action.payload);

        return newState;
      }

      break;

    case "edit/initiate":
      {
        let newState = { ...state };

        newState.selectedFeature = null;
        newState.highlightedFeatures = [];

        return newState;
      }

      break;

    case "layer/add": {
      let newState = { ...state };

      if (!newState.editableLayers[action.payload.id]) {
        if (action.payload.editable) {
          newState.editableLayers[action.payload.id] = action.payload;
        }
      }

      return newState;
    }

    case "edit/mergeDefaultFeature":
      {
        let newState = { ...state };

        newState.mergeDefaultFeature = action.payload;

        return newState;
      }
      break;

    case "layer/loaded": {
      let newState = { ...state };

      if (!newState.editableLayers[action.payload.layer.id]) {
        if (action.payload.layer.editable) {
          newState.editableLayers[action.payload.layer.id] =
            action.payload.layer;
        }
      }

      return newState;
    }

    case "layer/update": {
      let newState = cloneDeep(state);

      if (newState.editableLayers[action.payload.id]) {
        if (
          !newState.editableLayers[action.payload.id][action.payload.property]
        ) {
          newState.editableLayers[action.payload.id][action.payload.property] =
            "";
        }
        newState.editableLayers[action.payload.id][action.payload.property] =
          action.payload.value;
      }

      return newState;
    }

    case "edit/update/feature/property":
      {
        let newState = { ...state };

        if (!newState.selectedFeature._feature.properties) {
          newState.selectedFeature._feature.properties = {};
        }

        newState.selectedFeature._feature.properties[action.payload.property] =
          action.payload.value;

        return newState;
      }
      break;

    case "edit/highlightedFeatures":
      {
        let newState = { ...state };

        newState.highlightedFeatures = action.payload;

        return newState;
      }
      break;

    case "edit/selectFeature":
      {
        let newState = { ...state };

        let selected = action.payload.selected;

        let deselected = action.payload.deselected;

        deselected.forEach((el) => {
          let n = newState.highlightedFeatures
            .map((e) => {
              return e._featureId;
            })
            .indexOf(el);
          if (n >= 0) {
            newState.highlightedFeatures.splice(n, 1);
          }
        });

        selected.forEach((el) => {
          let n = newState.highlightedFeatures
            .map((e) => {
              return e._featureId;
            })
            .indexOf(el);

          if (n < 0) {
            newState.highlightedFeatures.push(el);
          }
        });

        if (newState.highlightedFeatures.length === 1) {
          newState.selectedFeature = newState.highlightedFeatures[0];
        } else {
          newState.selectedFeature = null;
        }

        return newState;
      }
      break;

    case "edit/save":
      {
        let newState = { ...state };

        newState.selectedFeature = null;

        return newState;
      }
      break;

    case "edit/update/feature/components":
      {
        let newState = { ...state };

        return newState;
      }
      break;

    case "edit/config/update":
      {
        let newState = { ...state };

        newState.editConfig[action.payload.property] = action.payload.value;

        return newState;
      }
      break;

    case "edit/select/layer":
      let newState = { ...state };

      newState.editLayer = action.payload;

      return newState;
      break;

    case "layer/deleteById": {
      let newState = cloneDeep(state);

      delete newState.editableLayers[action.payload];

      return newState;
    }

    default:
      return state;
  }
}
